"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._TypecheckDracoLoader = exports.DracoLoader = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _workerUtils = require("@loaders.gl/worker-utils");
var _version = require("./lib/utils/version");

var DEFAULT_DRACO_OPTIONS = {
  draco: {
    decoderType: (typeof WebAssembly === "undefined" ? "undefined" : (0, _typeof2.default)(WebAssembly)) === 'object' ? 'wasm' : 'js',
    libraryPath: 'libs/',
    extraAttributes: {},
    attributeNameEntry: undefined
  }
};

var DracoLoader = {
  name: 'Draco',
  id: _workerUtils.isBrowser ? 'draco' : 'draco-nodejs',
  module: 'draco',
  shapes: ['mesh'],
  version: _version.VERSION,
  worker: true,
  extensions: ['drc'],
  mimeTypes: ['application/octet-stream'],
  binary: true,
  tests: ['DRACO'],
  options: DEFAULT_DRACO_OPTIONS
};
exports.DracoLoader = DracoLoader;
var _TypecheckDracoLoader = DracoLoader;
exports._TypecheckDracoLoader = _TypecheckDracoLoader;
//# sourceMappingURL=draco-loader.js.map